import { useRouter } from 'next/router'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'

import { SortOptions } from '../utils/types/Product'
import { QueryParam } from '../utils/constants'

const useSortStateWithQuery = (): [
  SortOptions,
  Dispatch<SetStateAction<SortOptions>>,
] => {
  const { query } = useRouter()
  const sortQuery = query[QueryParam.sort] as SortOptions
  const [sortOption, setSortState] = useState<SortOptions>(sortQuery || '')

  useEffect(() => {
    if (!sortQuery) {
      setSortState('')
      return
    }
    if (sortQuery && typeof sortQuery === 'string' && sortQuery !== sortOption) {
      setSortState(sortQuery)
    }
  }, [sortQuery])

  return [sortOption, setSortState]
}

export default useSortStateWithQuery
